import { DOM_IDS, MOBILE_BREAKPOINT } from './constants.js'
import { isBasePortal, getWaffleMenuConfig } from './config.js'

function renderSlotAnchor(h, id) {
  return h('span', { id, style: { display: 'contents' } })
}

export function buildHeaderOptions({ ctx, logoText, rawConfig, onProfileMenuReady }) {
  const logoUrl = rawConfig?.logo?.url ?? ctx.brandingLogo
  const showRollbackToClassic =
    ctx.rollbackToClassicSupported &&
    !ctx.toggleControlBySetting &&
    window.innerWidth < MOBILE_BREAKPOINT

  return {
    logoUrl,
    logoText,
    productKey: ctx.productKey || undefined,
    systemFonts: false,
    waffleMenu: getWaffleMenuConfig(ctx),
    webBaseUrl: '/',
    delegateView: true,
    profileMenu: {
      enableCredit: true,
      target: isBasePortal({ ctx }) ? '_self' : '_blank',
      showRollbackToClassic,
      created: (instance, userInfo) => onProfileMenuReady?.(instance, userInfo ?? {})
    },
    slots: {
      left: (h) => renderSlotAnchor(h, DOM_IDS.LEFT_SLOTS),
      right: (h) => renderSlotAnchor(h, DOM_IDS.RIGHT_SLOTS)
    }
  }
}
